import { Requirements } from 'app/routes';

import {
    Account,
    InvoiceDetail,
    Refund,
    setAccount,
    setInvoice,
    setInvoiceId,
    setRefunds,
} from 'store/models/invoiceDetail';

const InvoiceDetailRequirements: Requirements<{
    details: { invoices: InvoiceDetail[]; accounts: Account[] };
    refunds: Refund[];
}> = {
    methods: ({ match }) => {
        const invoiceId = match?.params.invoiceId || '';
        return {
            details: {
                url: `/api/v1/backoffice/invoices/${invoiceId}/with_accounts`,
                cacheable: false,
            },
            refunds: {
                url: `/api/v1/backoffice/invoices/${invoiceId}/refunds`,
                cacheable: false,
            },
        };
    },
    resolve: ({
        result: {
            details: { invoices, accounts },
            refunds,
        },
        match,
    }) => [
        setInvoiceId(match?.params.invoiceId || ''),
        setAccount(accounts[0]),
        setInvoice(invoices[0]),
        setRefunds(refunds),
    ],
};
export default InvoiceDetailRequirements;
